import imageErrorHandler from '@/Data/Functions/imageErrors';
import message from '@/Data/Functions/message';
import { CreateNewWorker as CreateNewErrorHandlingWorker, LOGTYPE, SendLogRequest } from '@/Data/Functions/SeqLogger';

export default {
    install(Vue) {
        // Image error handler.
        imageErrorHandler();
        // Generic JS error handling
        CreateNewErrorHandlingWorker();
        RegisterErrorHandlers();
        // Vue Handlers
        RegisterVueErrorHandler(Vue);
        RegisterVueWarningHandler(Vue);
    }
};

/**
 * Handler, called when the resgister vue error.
 * @param {object} Vue The vue
 */
function RegisterVueErrorHandler(Vue) {
    Vue.config.errorHandler = (err, vm, info) => {

        const safeStackTrace = encodeURI(err.stack.toString());
        const vNode = vm?.$vnode?.tag || 'App Render',
            logData = {
                LogType: LOGTYPE.Error,
                LogMessage: `UI Error in ${vNode} > ${info} // ${err.toString()} | ${safeStackTrace}`
            },
            errorLocation = vNode.split(/-([0-9]+)-/gm).filter(e => isNaN(Number(e)))
                .join(' ');

        SendLogRequest(logData);
        DisplayFeedbackModal('UI Framework', err, errorLocation, 'error');
    };
}

/**
 * Registers the vue warning handler described by Vue.
 * @param {object} Vue The vue
 */
function RegisterVueWarningHandler(Vue) {
    Vue.config.warnHandler = (msg, vm, trace) => {
        const vNode = vm?.$vnode?.tag || 'App Render',
            logData = {
                LogType: LOGTYPE.Warning,
                LogMessage: `UI Warning in ${vNode} // ${trace} // ${msg}`
            };

        SendLogRequest(logData);
    };
}

/**
 * Displays a feedback modal.
 * @param {string} type The type
 * @param {object} err The error.
 * @param {string} location The location
 * @param {string} level The level
 */
function DisplayFeedbackModal(type, err, location, level) {
    message.showMessage(`
        <h2>${type} ${level.toTitleCase()}</h2>
        <p>${level.toTitleCase()} in <strong>${location}</strong></p>
        <p>${err.toString()}</p>
        <hr />
        <p>There has been an issue completing this task, it would be great help if you can contact the Citrus-Lime helpdesk so we can get this resolved in future releases of our product.</p>
    `, 'warning', 15000);
}

/**
 * Registers the error handlers.
 */
function RegisterErrorHandlers() {
    RegisterBaseJSErrorHandler();
    RegisterPromiseErrorHandler();
}

/**
 * Registers the base js error handler.
 */
function RegisterBaseJSErrorHandler() {
    window.addEventListener('error', (event) => {
        const { message, file, line, col, error } = event;
        let errorSerialized = null;

        try {
            errorSerialized = JSON.stringify(error, Object.getOwnPropertyNames(error));
        }
        catch(er) {
            // do nothing
        }

        const errorStack = errorSerialized ?? error?.stack ?? error?.toString() ?? '';
        const logData = {
            LogType: LOGTYPE.Error,
            LogMessage: `General Javascript Error // Message: ${message} // Location: ${file} (${line}, ${col}) // Error: ${errorStack}`
        };

        SendLogRequest(logData);
    });
}

/**
 * Registers the promise error handler.
 */
function RegisterPromiseErrorHandler() {
    window.addEventListener('unhandledrejection', (event) => {
        event.promise.catch((error) => {
            const logData = {
                LogType: LOGTYPE.Error,
                LogMessage: `Error in JS Promise // Message: ${event.reason} // Error: ${error.message} // Location: ${event.currentTarget.location}`
            };

            SendLogRequest(logData);
        });
    });
}
